import baseAPI from '@/api/baseAPI'

class TermsAPI extends baseAPI {
  get entity() {
    return {
      route: `/terms`,
      name: 'فصل دراسي'
    }
  }

  setAsCurrent(id){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${id}/set-as-current`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  currentCourseTerms(){
    return new Promise((resolve, reject) => {
      return this.request.get(`/current_course_terms`)
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

}

export default new TermsAPI()
